import { Link } from "react-router-dom";
import { Wind, Phone, Mail, MapPin } from "lucide-react";

const CITIES = [
  { slug: "bethesda-md", name: "Bethesda, MD" },
  { slug: "rockville-md", name: "Rockville, MD" },
  { slug: "silver-spring-md", name: "Silver Spring, MD" },
  { slug: "baltimore-md", name: "Baltimore, MD" },
  { slug: "annapolis-md", name: "Annapolis, MD" },
  { slug: "washington-dc", name: "Washington, DC" },
  { slug: "arlington-va", name: "Arlington, VA" },
  { slug: "alexandria-va", name: "Alexandria, VA" },
  { slug: "fairfax-va", name: "Fairfax, VA" },
];

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-surfaceAlt mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex w-9 h-9 rounded-full bg-forest text-white items-center justify-center">
              <Wind size={18} strokeWidth={1.75} />
            </span>
            <span className="font-heading text-base font-medium">Full Indoor Air Services</span>
          </div>
          <p className="text-sm text-muted2 leading-relaxed">
            Premium air duct, dryer vent & indoor air quality services across Maryland, DC, and Virginia.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href="tel:+18003737324" className="flex items-center gap-2 text-ink/80 hover:text-forest" data-testid="footer-phone">
              <Phone size={14} /> 1-800-FRESH-AIR
            </a>
            <a href="mailto:hello@capitalindoorair.com" className="flex items-center gap-2 text-ink/80 hover:text-forest" data-testid="footer-email">
              <Mail size={14} /> hello@capitalindoorair.com
            </a>
            <div className="flex items-center gap-2 text-ink/80">
              <MapPin size={14} /> Maryland · DC · Virginia
            </div>
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-ink/75 hover:text-forest">About</Link></li>
            <li><Link to="/services" className="text-ink/75 hover:text-forest">Services</Link></li>
            <li><Link to="/packages" className="text-ink/75 hover:text-forest">Packages</Link></li>
            <li><Link to="/contact" className="text-ink/75 hover:text-forest">Contact</Link></li>
            <li><Link to="/my-booking" className="text-ink/75 hover:text-forest" data-testid="footer-my-booking">Manage my booking</Link></li>
            <li><Link to="/admin/login" className="text-ink/55 hover:text-forest text-xs">Admin</Link></li>
          </ul>
        </div>

        <div className="col-span-2">
          <div className="eyebrow mb-4">Service Areas</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 text-sm">
            {CITIES.map((c) => (
              <Link
                key={c.slug}
                to={`/service-areas/${c.slug}`}
                className="text-ink/75 hover:text-forest"
                data-testid={`footer-city-${c.slug}`}
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between text-xs text-muted2">
          <div>© {new Date().getFullYear()} Full Indoor Air Services. All rights reserved.</div>
          <div className="mt-2 sm:mt-0">NADCA-aligned process · EPA-registered antimicrobials · Licensed & insured</div>
        </div>
      </div>
    </footer>
  );
}
